import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { TopBar } from "@/components/TopBar";
import { Spinner, EmptyState } from "@/components/common";
import { PersonCard } from "@/components/PersonCard";
import { Sparkles } from "lucide-react";

export default function Matches() {
  const [people, setPeople] = useState(null);
  const [savedIds, setSavedIds] = useState([]);
  useEffect(() => {
    api.get("/matches").then((r) => setPeople(r.data.people)).catch(() => setPeople([]));
    api.get("/saved/ids").then((r) => setSavedIds(r.data.ids)).catch(() => {});
  }, []);
  const onSave = (id, on) => setSavedIds((s) => (on ? [...s, id] : s.filter((x) => x !== id)));

  return (
    <div>
      <TopBar greeting="Your people" name="Matches" />
      <div className="px-4 pt-4">
        <div className="mb-4 flex items-center gap-2 rounded-2xl bg-brand-light p-3 text-sm text-brand-dark">
          <Sparkles className="h-4 w-4 shrink-0" /> Ranked by shared preferences — not a science, just a great starting point.
        </div>
        {people === null ? <Spinner /> : people.length ? (
          <div className="grid grid-cols-2 gap-4">
            {people.map((p) => <PersonCard key={p.user_id} person={p} savedIds={savedIds} onSaveChange={onSave} />)}
          </div>
        ) : <EmptyState icon={Sparkles} title="No matches yet" sub="Complete your profile to unlock better matches." />}
      </div>
    </div>
  );
}
